/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AccountCategoryEnum } from './accountCategoryEnum';
import { AccountProviderTypeEnum } from './accountProviderTypeEnum';
import { AccountValidations } from './accountValidations';
import { AccountStateEnum } from './accountStateEnum';


export interface Account { 
    /**
     * Account id
     */
    account_id: string;
    /**
     * Name for an account.
     */
    account_name?: string;
    provider: AccountProviderTypeEnum;
    state: AccountStateEnum;
    category: AccountCategoryEnum;
    /**
     * Org Id associated with account
     */
    org_id?: string;
    /**
     * Email-id of user who assigned org to account
     */
    assigned_by?: string;
    /**
     * Time when org was assigned to account.
     */
    assigned_on?: Date;
    /**
     * Batch Id to which this account belongs.
     */
    batch_id: string;
    /**
     * Owner account Id.
     */
    master_account_id: string;
    /**
     * Used for partitioning accounts.
     */
    org_unit?: string;
    /**
     * Team to which account belongs.
     */
    team?: string;
    validations?: AccountValidations;
    /**
     * Email-id of user who sent onboarding request
     */
    onboarded_by: string;
    /**
     * Time when account is onboarded.
     */
    onboarded_on: Date;
    /**
     * Email-id of user who modified account
     */
    modified_by?: string;
    /**
     * Time when account is modified.
     */
    modified_on?: Date;
    /**
     * Any comment related to account.
     */
    note?: string;
}
export namespace Account {
}


